import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class PageTitleService {
  pageTitleChanged: EventEmitter<string> = new EventEmitter<string>();

  setTitle(newTitle: string) {
    setTimeout(() => this.pageTitleChanged.emit(newTitle), 0);
  }
}
